import { render, staticRenderFns } from "./BoardShareDialog.vue?vue&type=template&id=376db247&scoped=true&"
import script from "./BoardShareDialog.vue?vue&type=script&lang=js&"
export * from "./BoardShareDialog.vue?vue&type=script&lang=js&"
import style0 from "./BoardShareDialog.vue?vue&type=style&index=0&id=376db247&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "376db247",
  null
  
)

export default component.exports